export default __webpack_public_path__ + "static/media/template2.fa368cae.png";